module.exports = new __parcel__URL__("linkedin.eb48cc27.svg").toString();